export default __webpack_public_path__ + "static/media/feature-image6.d37b5f8a.png";